import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogined: false,
  },
  mutations: {
    setLogin(state, data) {
      state.isLogined = data
    }
  },
  actions: {
  },
  modules: {
  }
})
